import { render, staticRenderFns } from "./CapacitacionCopasst.vue?vue&type=template&id=851267b8&"
import script from "./CapacitacionCopasst.vue?vue&type=script&lang=js&"
export * from "./CapacitacionCopasst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports